import { Typography } from "@mui/material";

export default function DetailsCard({ job }) {
  return (
    <>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {job.title?.toUpperCase()}
      </Typography>

      {job.company && (
        <Typography gutterBottom>
          <strong>Company:</strong> {job.company}
        </Typography>
      )}

      {job.location && (
        <Typography gutterBottom>
          <strong>Location:</strong>{" "}
          {job.location !== ""
            ? job.location
            : [job.city, job.state, job.country].filter(Boolean).join(", ")}
        </Typography>
      )}

      {job.summary && (
        <Typography gutterBottom>
          <strong>Summary:</strong> {job.summary}
        </Typography>
      )}

      {job.dutiesResponsibilities && (
        <Typography
          sx={{ mb: 1 }}
          component="div"
          dangerouslySetInnerHTML={{
            __html: job.dutiesResponsibilities || "",
          }}
        />
      )}

      {job.requiredEducation && (
        <Typography gutterBottom>
          <strong>Education:</strong> {job.requiredEducation}
        </Typography>
      )}

      {job.workplacePolicy && (
        <Typography gutterBottom>
          <strong>Workplace Policy:</strong> {job.workplacePolicy}
        </Typography>
      )}
    </>
  );
}
